import React from 'react'

import CompanyLogo from '../icon/CompanyLogo'

import { HeaderContainer } from './Header-styled'

export default () => {
  return (
    <HeaderContainer>
      <CompanyLogo className="HeaderLogo" />
    </HeaderContainer>
  )
}



// WEBPACK FOOTER //
// ./src/component/_presentational/Header/Header.jsx